import { isEmpty, isArray } from 'lodash';

import { MainStore } from '../store/store';
import { setErrors, setNotices } from '../store/ui';

export function checkErrorsAndNotices<T>(store: MainStore, data: T): T {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { error, notices } = data;

    if (error && !isEmpty(error)) {
        window.scrollTo(0, 0);
        store.dispatch(setErrors(isArray(error) ? error : [error]));
    }

    if (notices && !isEmpty(notices)) {
        window.scrollTo(0, 0);
        store.dispatch(setNotices(isArray(notices) ? notices : [notices]));
    }

    return data;
}
